import { render, staticRenderFns } from "./App.vue?vue&type=template&id=33ca25c2&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ca25c2')) {
      api.createRecord('33ca25c2', component.options)
    } else {
      api.reload('33ca25c2', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=33ca25c2&", function () {
      api.rerender('33ca25c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_price_versions/App.vue"
export default component.exports